import script from "./payrollPage.vue?vue&type=script&setup=true&lang=js"
export * from "./payrollPage.vue?vue&type=script&setup=true&lang=js"

import "./payrollPage.vue?vue&type=style&index=0&id=e907056e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e907056e"]])

export default __exports__